// extracted by mini-css-extract-plugin
module.exports = {"root":"bx_b9"};